import api from './index.js';

api.internals.register(api.sidemenu.SidemenuSelector.LIST, api.sidemenu.SidemenuList);

export default api;
